'use client';

import { type AxiosInstance } from 'axios';
import { createContext, useContext } from 'react';

import {
  AddressApi,
  AnimalSpeciesBreedApi,
  AuthorisedRepresentativeApi,
  BillableEventApi,
  CustomFieldApi,
  CustomFormApi,
  DocumentApi,
  EnterpriseActionApi,
  EnterpriseApi,
  EnterprisePrefixApi,
  EntityApi,
  EntityDetailApi,
  EntityDetailCategoryApi,
  EntityDetailConfigApi,
  EntityDetailEnhancerApi,
  EntityDetailValueApi,
  EntityTransferApi,
  FeeApi,
  FormActionAssociationApi,
  ImportBatchApi,
  FormApi,
  MembershipApi,
  MembershipBenefitApi,
  MembershipTypeApi,
  MembershipTypeBenefitAsscApi,
  NoteApi,
  OrganisationApi,
  OrganisationDto,
  OrganisationSettingApi,
  RoleUserOrgAssociationApi,
  RoleUserOrgAssociationDto,
  ScreenApi,
  TimelineApi,
  UserConfigApi,
  WorkOrderApi,
  ValidationApi as ValidationRuleApi,
  RuleConfigurationApi,
  RoleApi,
} from '@/apiClient';
import {
  UserApi,
  UserProfileApi,
  ValidationApi,
  type UserProfileDto,
} from '@/authApiClient';

export interface PrivateContextData {
  axiosInstance?: AxiosInstance;
  refreshToken?: string;
  token?: string;
  userId?: number;
  userGuid?: string;
  userEmail?: string;
  b2cFirstName?: string;
  b2cLastName?: string;
  userProfile?: UserProfileDto;
  reloadUserProfile?: () => void;
  loginFlowComplete?: boolean;
  userApi?: UserApi;
  userProfileApi?: UserProfileApi;
  validationApi?: ValidationApi;
  authorisedRepresentativeApi?: AuthorisedRepresentativeApi;
  billableEventApi?: BillableEventApi;
  addressApi?: AddressApi;
  animalSpeciesBreedApi?: AnimalSpeciesBreedApi;
  entityApi?: EntityApi;
  animalDetailApi?: EntityDetailApi;
  elsaApi?: AxiosInstance;
  entityDetailCategoryApi?: EntityDetailCategoryApi;
  entityDetailConfigApi?: EntityDetailConfigApi;
  entityDetailEnhancerApi?: EntityDetailEnhancerApi;
  entityDetailValueApi?: EntityDetailValueApi;
  entityTransferApi?: EntityTransferApi;
  customFormApi?: CustomFormApi;
  customFieldApi?: CustomFieldApi;
  documentApi?: DocumentApi;
  enterpriseApi?: EnterpriseApi;
  validationRuleApi?: ValidationRuleApi;
  enterpriseActionApi?: EnterpriseActionApi;
  enterprisePrefixApi?: EnterprisePrefixApi;
  feeApi?: FeeApi;
  formApi?: FormApi;
  roleApi?: RoleApi;
  formActionAssociationApi?: FormActionAssociationApi;
  importBatchApi?: ImportBatchApi;
  membershipApi?: MembershipApi;
  membershipTypeApi?: MembershipTypeApi;
  membershipBenefitApi?: MembershipBenefitApi;
  membershipTypeBenefitAsscApi?: MembershipTypeBenefitAsscApi;
  noteApi?: NoteApi;
  organisationApi?: OrganisationApi;
  organisationSettingApi?: OrganisationSettingApi;
  timelineApi?: TimelineApi;
  userConfigApi?: UserConfigApi;
  workOrderApi?: WorkOrderApi;
  screenApi?: ScreenApi;
  roleUserOrgAssociationApi?: RoleUserOrgAssociationApi;
  ruleConfigurationApi?: RuleConfigurationApi;
  entityDetailApi?: EntityDetailApi;
  selectedOrganisationId?: number;
  setSelectedOrganisationId?: (id: number) => void;
  selectedOrganisation?: OrganisationDto;
  setSelectedOrganisation?: (organistion: OrganisationDto) => void;
  userOrganisations?: RoleUserOrgAssociationDto[];
  setUserOrganisations?: (organisations: RoleUserOrgAssociationDto[]) => void;
  showSplashScreen?: boolean;
  setShowSplashScreen?: (show: boolean) => void;
}

const PrivateContext = createContext<PrivateContextData>({});

export const usePrivate = () => {
  return useContext(PrivateContext);
};

export const PrivateContextProvider = PrivateContext.Provider;
